import { LessonCompleteProfilePage } from "@app/grades/components/LessonCompleteProfilePage";
import { LessonDetailsPageContent } from "@app/grades/pages";
import { lessonAtom } from "@core/grades/atoms";
import { getLessonService } from "@core/grades/services";
import { toggleLessonLikeService } from "@core/grades/services/lessons.service";
import { publicRoutes } from "@framework/middleware";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { userAtom } from "../../../config/atoms";
import { getRootSettings, pageHead } from "../../../config/drivers";

export const loader = publicRoutes(async ({ params, http, success }) => {
  const { id } = params;

  const response = await getLessonService(http, id!);

  return success(response);
});

export const action = publicRoutes(
  async ({ params, http, body, success }) => {
    if ((body as { intent?: string })?.intent !== "like") {
      return success({});
    }

    const lessonId = Number(params.id);
    if (!lessonId) return success({});

    return success(await toggleLessonLikeService(http, lessonId));
  },
);

export default function LessonDetailsPage() {
  const {
    lesson,
    completeProfileFirst,
    message,
    profileVerificationPending,
    user,
    // Loader data can be null on the client (e.g. a failed revalidation),
    // which crashed this destructuring.
  } = useLoaderData<typeof loader>() ?? {};

  if (user) {
    userAtom.update(user);
  }

  if (lesson) {
    lessonAtom.update(lesson);

    return <LessonDetailsPageContent />;
  }

  if (completeProfileFirst) {
    return <LessonCompleteProfilePage message={message!} />;
  }

  if (profileVerificationPending) {
    // return <ProfileVerificationPendingPage />;
  }
}

export const meta: MetaFunction<typeof loader> = ({ data, matches }) => {
  const settings = getRootSettings(matches);

  return pageHead({
    title: data?.lesson?.name || "",
    appendAppName: true,
    image: data?.lesson?.image?.url || "",
    author: data?.lesson && {
      name: data?.lesson?.instructor?.name || "",
      image: data?.lesson?.instructor?.image?.url || "",
    },
    settings, // Pass settings for app name appending
  });
};
